import { render, staticRenderFns } from "./CreateDisputeForm.vue?vue&type=template&id=05455936&scoped=true&"
import script from "./CreateDisputeForm.vue?vue&type=script&lang=js&"
export * from "./CreateDisputeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05455936",
  null
  
)

export default component.exports